import React from 'react';
import PropTypes from 'prop-types';

export function SvgReverseArrows(props) {
  const { width = 14, height = 16, stroke = '#000' } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 16">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill={stroke} fillRule="nonzero" transform="translate(-530 -495)">
          <g transform="translate(259 386)">
            <g transform="translate(213 104)">
              <g transform="translate(40)">
                <g transform="translate(13 1)">
                  <g>
                    <path
                      d="M3.754 10.884c.058.073.15.116.246.116a.315.315 0 00.246-.116l3.692-4.631a.275.275 0 00.03-.304.31.31 0 00-.276-.16H6.154V.29C6.154.13 6.016 0 5.846 0H2.154c-.17 0-.308.13-.308.29v5.5H.308a.31.31 0 00-.276.16.275.275 0 00.03.303l3.692 4.631zM10 5a.315.315 0 00-.246.116L6.062 9.747a.275.275 0 00-.03.304.31.31 0 00.276.16h1.538v5.5c0 .16.138.289.308.289h3.692c.17 0 .308-.13.308-.29v-5.5h1.538a.31.31 0 00.276-.16.275.275 0 00-.03-.303l-3.692-4.631A.315.315 0 0010 5z"
                      transform="translate(5 4)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgReverseArrows.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
